import React, { useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiEdit, FiEye, FiInfo } from "react-icons/fi";
import {
  deleteTask,
  getAllEventTask,
  getAllTaskRevert,
  getMyEventTask,
  revertedTask,
} from "app/_services/ehs/ehsEventScheduleServices";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import TableExport from "app/views/custom/components/Export/TableExport";
import {
  capaPriorities,
  capaStatuses,
  validateRowFilter,
} from "../IncidentManagement/CONSTANTS";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import CompletionProof from "../CapaManagement/CompletionProof";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { ro } from "date-fns/locale";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { getLoggedInUserId } from "../IncidentManagement/Helper";
import {
  getTaskStatusClass,
  MEETING_STATUS,
  ohseTaskFilterFields,
  TASK_STATUS,
  TASK_STATUS_VIEW,
} from "./CONSTANT";
import {
  DDMMYYYYFormat,
  DDMMYYYYHHMMAFormat,
  YYYYMMDDFormat,
  isBetween,
} from "app/_helpers/dateHelper";
import { useForm } from "app/_helpers/hooks";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import OHSETaskFilter from "./Component/OHSETaskFilter";
import { ACTIVE_MODULE, moduleType } from "app/_constants/constant";
import { MdRefresh } from "react-icons/md";
import { FaRegTrashAlt } from "react-icons/fa";
import Decline from "../IncidentManagement/DeclinePopup";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import toastr from "toastr";
import { confirmAlert } from "react-confirm-alert";
// import { Loading } from "@gull";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import { GiReturnArrow } from "react-icons/gi";
import moment from "moment";
import CompletionProofPreview from "app/Components/CommanComponents/CompletionProofPreview";
import DeleteRecordIcon from "app/Components/DeleteRecordIcon/DeleteRecordIcon";

const ViewTask = ({
  match: {
    params: { siteId, id },
  },
  user,
}) => {
  const [tab, setTab] = useState(1);
  const [tabCount, setTabCount] = useState();
  const [revertTaskCount, setRevertTaskCount] = useState();
  const [taskDetails, setTaskDetails] = useState([]);
  const [taskFilter, setTaskFilter] = useState([]);
  const [taskRevert, setTaskRevert] = useState([]);
  const [tableOHSETaskList, setTableOHSETaskList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterForm, onChangeFilter, setFilterForm] = useForm({}, ohseTaskFilterFields);
  const [viewCompletionProof, setViewCompletionProof] = useState([]);
  const [showViewCompletionProof, setShowViewCompletionProof] = useState(false);

  const onReset = () => setFilterForm({});

  const taskList = useCallback(() => {
    // getAllEventTask().then((response) => {
    //   const data2 = response?.data?.map((data, index) => {
    //     const ownerDataObj = data?.taskOwners.find(
    //       (d) => d.ownerId === getLoggedInUserId()
    //     );
    //     return {
    //       ...data,
    //       sid: index + 1,
    //       ownerData:
    //         ownerDataObj?.userData?.firstName + " " + ownerDataObj?.userData?.lastName,
    //       eventId: data?.ohseData?.eventId,
    //       siteId: data?.ohseData?.siteId,
    //       scheduleId: data?.ohseData?.scheduleId,
    //       meetingLabel: data?.ohseData?.event?.meetingLabel,
    //       task_status: !ownerDataObj?.reverted
    //         ? ownerDataObj?.isTaskCompleted
    //           ? TASK_STATUS_VIEW.completed
    //           : TASK_STATUS_VIEW.open
    //         : "Returned",
    //       task_status1: !ownerDataObj?.reverted
    //         ? TASK_STATUS_VIEW[data?.taskStatus]
    //         : "Returned",
    //       isTaskRevert: ownerDataObj?.reverted,
    //     };
    //   });
    //   setTaskDetails(data2);
    // });
    const fetchData = async () => {
      try {
        const response = await getAllEventTask();

        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        const data2 = response?.data?.map((data, index) => {
          const ownerDataObj = data?.taskOwners.find(
            (d) => d.ownerId === getLoggedInUserId()
          );
          return {
            ...data,
            sid: index + 1,
            ownerData:
              ownerDataObj?.userData?.firstName + " " + ownerDataObj?.userData?.lastName,
            eventId: data?.ohseData?.eventId,
            siteId: data?.ohseData?.siteId,
            scheduleId: data?.ohseData?.scheduleId,
            meetingLabel: data?.ohseData?.event?.meetingLabel,
            task_status: !ownerDataObj?.reverted
              ? ownerDataObj?.isTaskCompleted
                ? TASK_STATUS_VIEW.completed
                : TASK_STATUS_VIEW.open
              : "Returned Task",
            task_status1: !ownerDataObj?.reverted
              ? TASK_STATUS_VIEW[data?.taskStatus]
              : "Returned Task",
            isTaskRevert: ownerDataObj?.reverted,
            taskDueDate: data?.taskDueDate ? DDMMYYYYFormat(data?.taskDueDate) : "",
            completionDateFormatted: data?.completionDate
              ? DDMMYYYYFormat(data?.completionDate)
              : "In Progress",
            locationName: data?.ohseData?.site?.name,
          };
        });
        setTaskDetails(data2);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const taskRevertList = () => {
    getAllTaskRevert().then((response) => {
      if (!response?.status) return;
      const finalList = [];
      const revertList = response?.data.map((d) =>
        d?.taskOwners.map((obj) => {
          const objOwner = {
            ...d,
            // ownerData: obj,
            ownerData: obj?.userData?.firstName + " " + obj?.userData?.lastName,
            eventId: d?.ohseData?.eventId,
            siteId: d?.ohseData?.siteId,
            scheduleId: d?.ohseData?.scheduleId,
            meetingLabel: d?.ohseData?.event?.meetingLabel,
            task_status: !obj?.reverted
              ? obj?.isTaskCompleted
                ? TASK_STATUS_VIEW.completed
                : TASK_STATUS_VIEW.open
              : "Returned Task",
            isTaskRevert: obj?.reverted,
            taskOwnerId: obj?.ownerId,
            taskDueDate: d?.taskDueDate ? DDMMYYYYFormat(d?.taskDueDate) : "",
            completionDateFormatted: d?.completionDate
              ? DDMMYYYYFormat(d?.completionDate)
              : "In Progress",
            locationName: d?.ohseData?.site?.name,
          };
          finalList.push(objOwner);
        })
      );
      setTaskRevert(finalList);
    });
    const fetchData = async () => {
      try {
        const response = await getAllTaskRevert();

        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        const finalList = [];
        const revertList = response?.data.map((d) =>
          d?.taskOwners.map((obj) => {
            const objOwner = {
              ...d,
              // ownerData: obj,
              ownerData: obj?.userData?.firstName + " " + obj?.userData?.lastName,
              eventId: d?.ohseData?.eventId,
              siteId: d?.ohseData?.siteId,
              scheduleId: d?.ohseData?.scheduleId,
              meetingLabel: d?.ohseData?.event?.meetingLabel,
              task_status: !obj?.reverted
                ? obj?.isTaskCompleted
                  ? TASK_STATUS_VIEW.completed
                  : TASK_STATUS_VIEW.open
                : "Returned",
              isTaskRevert: obj?.reverted,
              taskOwnerId: obj?.ownerId,
              taskDueDate: d?.taskDueDate ? DDMMYYYYFormat(d?.taskDueDate) : "",
              completionDateFormatted: d?.completionDate
                ? DDMMYYYYFormat(d?.completionDate)
                : "In Progress",
              locationName: d?.ohseData?.site?.name,
            };
            finalList.push(objOwner);
          })
        );
        setTaskRevert(finalList);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };
    fetchData();
  };

  useEffect(() => {
    taskList();
  }, []);

  useEffect(() => {
    taskRevertList();
  }, []);

  useEffect(() => {
    setTaskFilter(
      tab !== 4
        ? taskDetails?.filter((row) => {
            let TRUE_FALSE = false;
            if (
              tab === 1 &&
              !!row?.taskOwners?.find(
                (d) => getLoggedInUserId() === d?.ownerId && !d?.isTaskCompleted
              )
            ) {
              TRUE_FALSE = true;
            }
            if (
              tab === 2 &&
              !!row?.taskOwners?.find(
                (d) => getLoggedInUserId() === d?.ownerId && d?.isTaskCompleted
              )
            ) {
              TRUE_FALSE = true;
            }
            if (tab === 3) {
              TRUE_FALSE = true;
            }
            // if (
            //   tab === 4 &&
            //   getLoggedInUserId() === row?.createdBy &&
            //   row?.ownerData?.reverted
            // ) {
            //   TRUE_FALSE = true;
            // }
            return TRUE_FALSE;
          })
        : taskRevert
    );
  }, [tab, taskDetails, taskRevert]);

  useEffect(() => {
    if (tab === 3) {
      setTableOHSETaskList(
        taskFilter
          ?.map((data) => {
            const aa = data?.taskOwners?.map((d) => {
              return d?.userData?.firstName + " " + d?.userData?.lastName;
            });
            return {
              ...data,
              ownerData: aa.join(","),
              task_status: data.task_status1,
            };
          })
          ?.filter?.((data) => {
            let flag = true;
            if (filterForm?.startDate && filterForm?.endDate) {
              let dueDate = moment(data.taskDueDate, "DD-MM-YYYY");
              flag = isBetween(
                YYYYMMDDFormat(dueDate),
                YYYYMMDDFormat(filterForm.startDate),
                YYYYMMDDFormat(filterForm.endDate)
              );
            }

            if (filterForm?.taskOwnerId) {
              const ownerObj = data?.taskOwners?.find(
                (d) => d.ownerId === filterForm?.taskOwnerId
              );
              if (!ownerObj) flag = false;
            }

            if (flag) flag = validateRowFilter(filterForm, data);
            return flag;
          })
      );
    } else
      setTableOHSETaskList(
        taskFilter?.map((d) => ({ ...d, task_status: d?.task_status1 }))
      );
  }, [filterForm, tab, taskFilter]);

  const revertTask = (taskId, obj) => {
    revertedTask(taskId, obj).then((response) => {
      if (response?.status) toastr.success("Returned Successfully");
      setTaskDetails([]);
      taskList();
      taskRevertList();
    });
  };

  const deleteRow = (id, obj) => {
    confirmAlert({
      title: "Delete Task",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let response = await deleteTask(id, obj);

            if (!response?.status) return toastr.info(response?.message);

            toastr.info(response?.message || "Deleted Successfully!");
            setTaskDetails([]);
            taskList();
            taskRevertList();
            setTab(1);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const updateTab = (n) => {
    //setTaskFilter([]);
    setTableOHSETaskList([]);
    setTab(n);
  };

  useEffect(() => {
    if (tab === 1) setTabCount(tableOHSETaskList?.length);
  }, [tableOHSETaskList?.length, tab]);
  console.log("tableOHSETaskList______desk_____________", tableOHSETaskList);

  useEffect(() => {
    const isCount = taskDetails?.filter(
      (row) => getLoggedInUserId() === row?.createdBy && row?.ownerData?.reverted
    )?.length;
    setRevertTaskCount(isCount);
  }, [taskDetails]);

  const handleViewCompletionProof = (data) => {
    setViewCompletionProof(data);
    setShowViewCompletionProof(true);
  };

  const closeCompletionProof = () => {
    setViewCompletionProof([]);
    setShowViewCompletionProof(false);
  };

  const { SearchBar } = Search;
  const sortableColumn = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: false,
      },
      {
        dataField: "taskId",
        text: "Task ID",
        sort: true,
        formatter: (taskId, row) => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">View</Tooltip>}
          >
            <Link
              className="icons text-cyanBlue"
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/audits-meetings/view-owner/" +
                row.id
              }
            >
              {taskId}
            </Link>
          </OverlayTrigger>
        ),
      },
      {
        dataField: "scheduleId",
        text: "OHSE Review ID",
        sort: true,
        formatter: (scheduleId, row) => row?.ohseData?.scheduleId,
        // formatter: (scheduleId, row) => (
        //   <OverlayTrigger
        //     placement="top"
        //     overlay={<Tooltip id="tooltip-top">View</Tooltip>}
        //   >
        //     <Link
        //       className="icons text-cyanBlue"
        //       to={
        //         (row?.ohseData?.eventStatus === MEETING_STATUS.draft || row?.ohseData?.eventStatus === MEETING_STATUS.planned
        //           ? "/health-safety-and-environment/audits-meetings/scheduled-event/view/"
        //           : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/") + row?.ohseData?.id
        //       }
        //     >
        //       {row?.ohseData?.scheduleId}
        //     </Link>
        //   </OverlayTrigger>
        // ),
      },
      {
        dataField: "locationName",
        text: "Location Name",
        sort: true,
        // formatter: (site, row) => {
        //   return `${row?.site?.name}`;
        // },
      },
      {
        dataField: "taskDescription",
        text: "Task Description",
        sort: true,
        classes: "text-wrap",
      },
      {
        dataField: "ownerData",
        text: "Task Owner",
        sort: true,
        formatter: (id, row) => {
          console.log("row?.ownerData", row);
          return `${row?.ownerData}`;
        },
      },
      {
        dataField: "taskDueDate",
        text: "Due Date",
        sort: true,
        // formatter: (rowContent) => DDMMYYYYFormat(rowContent),
      },
      {
        dataField: "completionDateFormatted",
        text: "Completion Date",
        sort: true,
        formatter: (completionDate, row) =>
          row?.completionDate ? DDMMYYYYHHMMAFormat(row?.completionDate) : "In Progress",
      },
      {
        dataField: "task_status",
        text: "Status",
        formatter: (status, row) => {
          return (
            <div
              className={
                !row?.isTaskRevert
                  ? getTaskStatusClass(status)
                  : "bg-primary text-white rounded text-center"
              }
            >
              {!row?.isTaskRevert ? (
                status
              ) : (
                <>
                  Returned Task <GiReturnArrow className="ml-2" size={18} />
                </>
              )}
            </div>
          );
        },
      },
      {
        dataField: "formattedCompletionProof",
        text: "Completion Proof",
        sort: true,
        formatter: (rowContent, row) => {
          const isCompletionProof =
            row?.taskOwners?.find((obj) => obj?.completionProofId) || false;
          return isCompletionProof ? (
            <OverlayTrigger
              placement="left"
              overlay={<Tooltip id="tooltip-top">Completion Proof</Tooltip>}
            >
              <span
                onClick={() => handleViewCompletionProof(row?.taskOwners)}
                className="actionIconsGroup"
              >
                <FiInfo size={18} style={{ color: "#2bb0e5" }} />
              </span>
            </OverlayTrigger>
          ) : (
            ""
          );
        },
      },
      {
        dataField: "createdAt",
        text: "Time Stamp",
        sort: true,
        formatter: (createdAt, row) => {
          return DDMMYYYYHHMMAFormat(createdAt);
        },
      },

      {
        dataField: "id",
        text: "Action",
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">View</Tooltip>}
              >
                <Link
                  to={{
                    pathname:
                      (siteId ? `/sites/${siteId}` : "") +
                      "/health-safety-and-environment/audits-meetings/view-owner/" +
                      row.id,
                    state: { ownerId: row?.ownerData?.ownerId },
                  }}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </OverlayTrigger>
              {tab === 1 && !row?.isTaskRevert && (
                <>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Update</Tooltip>}
                  >
                    <Link
                      to={{
                        pathname:
                          (siteId ? `/sites/${siteId}` : "") +
                          "/health-safety-and-environment/audits-meetings/edit-owner/" +
                          row.id,
                        state: { ownerId: row?.ownerData?.ownerId },
                      }}
                      className="icons text-cyanBlue"
                    >
                      <FiEdit />
                    </Link>
                  </OverlayTrigger>

                  <Decline
                    onSubmit={(obj) =>
                      revertTask(row?.id, {
                        revertMessage: obj.comment,
                        taskOwnerId: row?.ownerData?.ownerId,
                      })
                    }
                    title="Return"
                    name={
                      <CustomTooltip tooltip="Return">
                        <MdRefresh size={20} />
                      </CustomTooltip>
                    }
                    iconClass={"icons text-cyanBlue"}
                  />
                </>
              )}
              {tab === 4 && (
                <>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Update</Tooltip>}
                  >
                    <Link
                      to={{
                        pathname:
                          (siteId ? `/sites/${siteId}` : "") +
                          "/health-safety-and-environment/audits-meetings/update-task/" +
                          row.id,
                        state: { ownerId: row?.taskOwnerId },
                      }}
                      className="icons text-cyanBlue"
                    >
                      <FiEdit />
                    </Link>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                  >
                    <span
                      onClick={() => deleteRow(row?.id, { ownerId: row?.taskOwnerId })}
                      className="icons text-danger pointer"
                    >
                      <FaRegTrashAlt />
                    </span>
                  </OverlayTrigger>
                </>
              )}
              {tab === 3 && (
                <DeleteRecordIcon
                  id={row?.id}
                  moduleType={moduleType.ehs_meeting_tasks}
                  setLoading={setLoading}
                  reloadData={() => {
                    taskList();
                    taskRevertList();
                  }}
                />
              )}
            </div>
          );
        },
      },
    ],
    [siteId, tab]
  );

  const rowStyle = (row) => {
    if (row?.isTaskRevert && tab !== 4) {
      return { backgroundColor: "#d2ced6" };
    }
  };
  const tableToolbarBeforeView = () =>
    showFilter &&
    tab === 3 && (
      <OHSETaskFilter
        fields={ohseTaskFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChangeFilter}
        onReset={onReset}
      />
    );

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "OHSE Review",
            path: "/health-safety-and-environment/audits-meetings",
          },
          { name: "OHSE Review Tasks" },
        ]}
        module={ACTIVE_MODULE.ohse}
      />

      <div className="card p-3">
        <div className="simple-card-title">
          <h3 class="text-capitalize mb-1">Manage Tasks</h3>
          {tab === 3 && <FilterBtn setShowFilter={setShowFilter} />}
          <BackBtn
            url={
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/audits-meetings/"
            }
          />
        </div>
        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-2">
          <div className="hseMenuLinks card">
            <a
              href
              onClick={() => updateTab(1)}
              className={`pointer${tab === 1 ? " active" : ""}`}
            >
              My Meetings Task ({tabCount})
            </a>
            <a
              href
              onClick={() => updateTab(2)}
              className={`pointer${tab === 2 ? " active" : ""}`}
            >
              My Task History
            </a>
            <a
              href
              onClick={() => updateTab(3)}
              // style={{pointerEvents: 'none'}}
              className={`pointer${tab === 3 ? " active" : ""}`}
            >
              View Tasks
            </a>
            {taskRevert?.length ? (
              <a
                href
                onClick={() => updateTab(4)}
                // style={{pointerEvents: 'none'}}
                className={`pointer${tab === 4 ? " active" : ""}`}
              >
                Returned Tasks ({taskRevert?.length})
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="material-master-table">
          {loading ? (
            <NetZeroLoader />
          ) : (
            <>
              {tab === 1 ? (
                <SearchBootstrapTable
                  rowStyle={rowStyle}
                  searchKey={"myMeetingsTaskDesktopSearch"}
                  data={tableOHSETaskList?.map((d, idx) => ({ ...d, sid: idx + 1 }))}
                  columns={sortableColumn}
                  tableBeforeSearch={tableToolbarBeforeView}
                  tableKey="myMeetingsTask"
                />
              ) : (
                <div>
                  <SearchBootstrapTable
                    rowStyle={rowStyle}
                    searchKey={"OHSEReviewTaskDesktopSearch"}
                    data={tableOHSETaskList?.map((d, idx) => ({ ...d, sid: idx + 1 }))}
                    columns={sortableColumn}
                    tableBeforeSearch={tableToolbarBeforeView}
                    tableKey="OHSEReviewTask"
                  />
                </div>
              )}
            </>
          )}

          <br />
        </div>

        {/* <ToolkitProvider
          striped
          keyField="id"
          data={taskDetails}
          columns={sortableColumn}
          search={{
            searchFormatted: true,
          }}
        >
          {(props) => (
            <>
              <div className="d-flex align-items-center justify-content-between pb-3">
                <SearchBar {...props.searchProps} className="mb-0" />
                <div className="btn-toolbar">

                  <TableExport
                    tableName={"CompleteOwnerPaymentHistory"}
                    dataColumn={sortableColumn}
                    renderData={taskDetails}
                    searchText={props.searchProps.searchText}
                  ></TableExport>
                </div>
              </div>
              <div className="table-responsive material-master-table">
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4
                  noDataIndication={"Table is empty"}
                />
              </div>
            </>
          )}
        </ToolkitProvider> */}
        <CompletionProofPreview
          data={viewCompletionProof}
          isShow={showViewCompletionProof}
          closeCompletionProof={closeCompletionProof}
        />
      </div>
    </div>
  );
};

export default connect((state) => ({ user: state.user.user }))(ViewTask);
